import { render, staticRenderFns } from "./index-shops.vue?vue&type=template&id=7574a907&scoped=true&"
import script from "./index-shops.vue?vue&type=script&lang=js&"
export * from "./index-shops.vue?vue&type=script&lang=js&"
import style0 from "./index-shops.vue?vue&type=style&index=0&id=7574a907&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7574a907",
  null
  
)

export default component.exports